export default __webpack_public_path__ + "static/media/5-min.dee4f921.jpg";